import { FC } from 'react';
import { useOperationDetailsPage } from '../context/OperationDetailsPageContext';
import { operationTableBodyMap } from '../constants/operationTableBodyMap';

const OperationDetailsTableBody: FC = () => {
  const { data } = useOperationDetailsPage();

  const OperationComponent =
    data.operation?.operationType &&
    operationTableBodyMap[data.operation.operationType];

  return (OperationComponent && <OperationComponent />) || null;
};

export default OperationDetailsTableBody;
